export default __webpack_public_path__ + "static/media/autotone_after.91e0da7a.png";